import React from 'react';
import './Loading06.css';

const LoadingText = () => {
  return (
    <div className="loading loading06">
      <span data-text="A">A</span>
      <span data-text="y">y</span>
      <span data-text="u">u</span>
      <span data-text="D">D</span>
      <span data-text="o">o</span>
      <span data-text="s">s</span>
      <span data-text="t">t</span>
    </div>
  );
};

export default LoadingText;
